<style lang="less" rel="stylesheet/less" scope>
  .fallback-img {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
    }
    .hidden {
      display: none;
    }
  }
</style>
<template>
  <div class="fallback-img">
    <img :src="imageSrc" ref="img" :class="{'hidden': isHide}">
  </div>
</template>
<script type='text/ecmascript-6'>
  import defaultImg from '@/assets/login/header.jpg'
  import { mapState } from 'vuex'

  export default {
    name: 'fallbackImage',
    props: ['srcs', 'defaultImage'],
//    props: {
//      srcs: {
//        type: String,
 //         default:  defaultImg
//        required: true
//      },
//      defaultImage: {
//        type: String
//      }
//    },
    computed: mapState({api: state => state.api}),
    data: () => ({
      imageSrc: '',
      isHide: true,
      defaultImg,
    }),
    mounted () {
      this.$nextTick(function () {
        this.$refs.img.onerror = () => {
          this.imageSrc = this.defaultImage;
        }
      })
    },
    watch: {
      srcs(val) {
        this.imageSrc = val ? this.api.BASE_API + val : this.defaultImage;
        this.isHide = false;
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/login/fallback-image.vue